import { ChevronLeft, ChevronRight } from 'lucide-react';
import { BACK_BTN, PRIMARY_BTN } from '../helper';

const DOT_STYLE = {
  done: 'w-1.5 bg-teamcare-blue',
  active: 'w-5 bg-teamcare-blue',
  upcoming: 'w-1.5 bg-secondary-200',
};

const dotStatus = (step, current) => (step < current ? 'done' : step === current ? 'active' : 'upcoming');

const Dots = ({ current, total }) => (
  <div className="flex items-center gap-1">
    {Array.from({ length: total }, (_, index) => {
      const step = index + 1;
      return <span key={step} className={`h-1.5 rounded-full transition-all ${DOT_STYLE[dotStatus(step, current)]}`} />;
    })}
  </div>
);

const Frame = ({ stepId, current, total, onBack, onCancel, footer = true, submitLabel = 'Continue', isSubmitting = false, children }) => (
  <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white">
    <div className="flex items-center gap-3 border-b border-gray-100 px-4 py-3 sm:px-5">
      <button type="button" onClick={onBack} disabled={isSubmitting} aria-label="Back" className={BACK_BTN}>
        <ChevronLeft size={16} strokeWidth={2.5} />
      </button>

      <p className="flex-1 text-[11px] font-semibold uppercase tracking-wider text-secondary-400">
        Insurance · Step {current} of {total}
      </p>

      <Dots current={current} total={total} />
    </div>

    <div key={stepId} className="animate-slide-up px-4 py-5 sm:px-6">
      {children}
    </div>

    {footer && (
      <div className="flex items-center justify-between gap-3 border-t border-gray-100 px-4 py-3 sm:px-6 sm:py-3.5">
        <button
          type="button"
          onClick={onCancel}
          disabled={isSubmitting}
          className="text-[13px] font-semibold text-secondary-400 transition-colors hover:text-secondary-600 disabled:opacity-60 sm:text-sm"
        >
          Cancel
        </button>

        <button type="submit" disabled={isSubmitting} className={PRIMARY_BTN}>
          {isSubmitting ? (
            <span className="loading loading-spinner loading-sm" />
          ) : (
            <>{submitLabel} <ChevronRight size={15} strokeWidth={2.5} /></>
          )}
        </button>
      </div>
    )}
  </div>
);

export default Frame;
